/**
 * Branded artefact titles often embed the legal entity with all spaces removed, then the doc title, e.g.
 * "ResilincSolutionsPrivateLimited(India)Management responsibilities"
 * This matches `companyName` like "Resilinc Solutions Private Limited (India)" → compact prefix.
 */

/**
 * @param {string} [companyName]
 * @returns {string}
 */
export function companyNameAsFilenamePrefix(companyName) {
  if (!companyName || typeof companyName !== "string") return "";
  return companyName.replace(/\s+/g, "").trim();
}

/**
 * @param {string} [documentName]
 * @param {string} [companyName]
 * @returns {string}
 */
export function stripCompanyPrefixFromDocumentTitle(documentName, companyName) {
  const name = String(documentName || "").trim();
  const prefix = companyNameAsFilenamePrefix(companyName);
  if (!name || !prefix) return name;
  const nl = name.toLowerCase();
  const pl = prefix.toLowerCase();
  if (!nl.startsWith(pl)) return name;
  let i = 0;
  while (i < prefix.length && i < name.length && name[i].toLowerCase() === prefix[i].toLowerCase()) {
    i += 1;
  }
  const rest = name.slice(i).trim();
  return rest || name;
}
